import {
  Input,
  InputGroup,
  InputLeftElement,
  InputRightElement,
  IconButton,
  useColorModeValue,
  Box,
} from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';
import { CustomSearchIcon } from '../../theme/icons/CustomSearchIcon';
import { useContext, useState } from 'react';
import PassesListContext from '../../store/client/PassesListContext';
import { CustomReactSelect } from './CustomReactSelect';

export function CustomPassIdSearchBar() {
  const passListCtx = useContext(PassesListContext);
  const modeBgColor = useColorModeValue('white', 'secondaryDark');
  const [searchValue, setSearchValue] = useState('');
  const [searchType, setSearchType] = useState({
    value: 'extId',
    label: 'Ext ID ',
  });

  const searchTypeOptions = [
    {
      value: 'uuid',
      label: 'UUID',
      tooltip: 'Exact match of the UUID',
    },
    {
      value: 'extId',
      label: 'Ext ID',
      tooltip: 'Exact match of the external ID',
    },
    {
      value: 'extIdPrefix',
      label: 'Ext ID Prefix',
      tooltip: 'Match the beginning characters of the external ID',
    },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();

    const clearedFilters = {
      uuid: '',
      extId: '',
      extIdPrefix: '',
    };

    passListCtx.updateFilterValues({
      ...passListCtx.filterValues,
      ...clearedFilters,
      [searchType.value]: searchValue.trim(),
    });
  };

  const handleInputChange = (e) => {
    setSearchValue(e.target.value);
  };

  const handleSearchTypeChange = (selectedOption) => {
    setSearchType(selectedOption);
  };

  const handleClearInput = () => {
    setSearchValue('');
  };

  return (
    <InputGroup
      as="form"
      onSubmit={handleSubmit}
      w={{ base: '100%', sm: '60%' }}
      mr={2}
    >
      <InputLeftElement
        width="150px"
        height="full"
        justifyContent="start"
        borderRadius="12px"
      >
        <CustomReactSelect
          options={searchTypeOptions}
          value={searchType}
          onChange={handleSearchTypeChange}
          isSearchable={false}
          isClearable={false}
          id="idSearchType"
        />
      </InputLeftElement>
      <Input
        borderRadius="12px"
        alignSelf={{ base: 'flex-start', sm: 'center' }}
        pl="160px"
        pr={searchValue ? '75px' : '40px'}
        fontSize="12px"
        fontWeight="bold"
        w="full"
        bg={modeBgColor}
        height="36px"
        type="text"
        placeholder={`Search by ${searchType.label.toLowerCase()}`}
        value={searchValue}
        onChange={handleInputChange}
      />
      <InputRightElement width={searchValue ? '70px' : '36px'} height="36px">
        {searchValue && (
          <>
            <IconButton
              aria-label="Clear search"
              icon={<CloseIcon />}
              size="xs"
              fontSize="10px"
              variant="ghost"
              _hover={{ bg: 'gray.100' }}
              onClick={handleClearInput}
            />

            <Box
              as="span"
              mx={1}
              borderLeft="1px"
              borderColor="gray.300"
              height="20px"
            />
          </>
        )}
        <IconButton
          type="submit"
          aria-label="Search"
          icon={<CustomSearchIcon name="search" />}
          size="xs"
          variant="ghost"
        />
      </InputRightElement>
    </InputGroup>
  );
}
